<template>
    <portal to="page-loader">
        <div class="page-loader-wrapper">
            <transition name="page-loader">
                <b-progress v-if="show" :value="value" :max="max" animated height="0.2rem"></b-progress>
            </transition>
        </div>
    </portal>
</template>

<script>
    export default {
        name: "PageLoader",
        props: {
            max: {
                type: Number,
                default: 100
            },
            value:{
                type: Number,
                default: 0
            }
        },
        computed: {
            show(){
                return this.$props.value > 0 && this.$props.value < this.$props.max;
            }
        }
    }
</script>